module.exports = __webpack_public_path__ + "static/media/ic_user.774a4d7d.png";